import { render, staticRenderFns } from "./OptOut.vue?vue&type=template&id=0bd95b32&scoped=true"
import script from "./OptOut.vue?vue&type=script&lang=js"
export * from "./OptOut.vue?vue&type=script&lang=js"
import style0 from "./OptOut.vue?vue&type=style&index=0&id=0bd95b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd95b32",
  null
  
)

export default component.exports